import { Button, BodyText, HeadingText } from '@paypalcorp/pp-react';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import Illustration from '../illustrations/Illustration';
import { Message } from '@paypalcorp/worldready-react';
import {
  trackUpdatesLoginButtonPressed,
  trackUpdatesLoginIM,
  trackUpdatesLoginSignupPressed,
} from '../../fpti/fpti';

const LoginPopup = ({ showSignup, orgName }) => {
  useEffect(() => {
    trackUpdatesLoginIM();
  }, []);

  const logInUser = () => {
    trackUpdatesLoginButtonPressed();
    const url = new URL(window.location.href);
    const encodedStateUrl = encodeURIComponent(url.search);
    const encodedReturnUrl = encodeURIComponent(url.pathname);

    const renderURL = `/signin?forceLogin=true&intent=donate&returnUri=${encodedReturnUrl}&state=${encodedStateUrl}`;
    window.location.href = renderURL;
  };

  const signupUser = () => {
    trackUpdatesLoginSignupPressed();
    /**
     * TODO: Create Signup logic
     * */
  };

  return (
    <div className="login-popup">
      <Illustration type="heart" className="login-popup-icon" />
      <HeadingText level={2} className="login-popup-title">
        <Message id="common.loginPopup.popup.title" />
      </HeadingText>
      <BodyText className="login-popup-desc">
        <Message
          id={`common.loginPopup.popup${showSignup ? '.signup' : ''}.desc`}
          orgName={orgName}
        />
      </BodyText>

      <div className="login-popup-buttongroup">
        <Button onClick={logInUser}>
          <Message id="common.loginPopup.popup.loginButton" />
        </Button>
        {showSignup && (
          <Button secondary onClick={signupUser}>
            <Message id="common.loginPopup.popup.signupButton" />
          </Button>
        )}
      </div>
    </div>
  );
};

LoginPopup.propTypes = {
  showSignup: PropTypes.bool,
  orgName: PropTypes.string,
  returnUri: PropTypes.string,
};

export default LoginPopup;
